import Section from 'components/base/Section';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import EcomWishlistTable from 'components/tables/EcomWishlistTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const Wishlist = () => {
  const { wishlist } = useSelector((state: RootState) => state.user.wishlist);

  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
        <h2 className="mb-5">
          Wishlist
          <span className="text-body-tertiary fw-normal ms-2">
            ({wishlist.length})
          </span>
        </h2>
        <EcomWishlistTable />
      </Section>
    </div>
  );
};

export default Wishlist;
